import { render, staticRenderFns } from "./MaterialPrices.vue?vue&type=template&id=daab69c8&scoped=true"
import script from "./MaterialPrices.vue?vue&type=script&lang=ts"
export * from "./MaterialPrices.vue?vue&type=script&lang=ts"
import style0 from "./MaterialPrices.vue?vue&type=style&index=0&id=daab69c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daab69c8",
  null
  
)

export default component.exports